import { FC } from "react"
import { KTCard } from "../../../../../../_metronic/helpers"
import { DLMSiteApplicationsListProps, DLMSiteApplicationsListContextProvider, DLMSiteApplicationsListHeader } from "./components"

import { DLMSiteApplicationsTable } from "./table/DLMSiteApplicationsTable"

const DLMSiteApplicationsList:FC<DLMSiteApplicationsListProps> = ({sites, workflow, applicationOwnerId}) => {
  return (
    <DLMSiteApplicationsListContextProvider sites={sites} workflow={workflow} applicationOwnerId={applicationOwnerId}>
      <KTCard>
        <DLMSiteApplicationsListHeader  />
        <DLMSiteApplicationsTable />
      </KTCard>  
    </DLMSiteApplicationsListContextProvider>
  )
}

export { DLMSiteApplicationsList }